import { pluralize } from '../../utils';
import styles from './birthday-banner.module.less';
import { Icon } from '@sb1/ffe-icons-react';
import cake from '@sb1/ffe-icons/icons/open/300/md/cake.svg';
import flower from '@sb1/ffe-icons/icons/open/300/md/local_florist.svg';
import celebration from '@sb1/ffe-icons/icons/open/300/md/celebration.svg';
import card from '@sb1/ffe-icons/icons/open/300/md/loyalty.svg';

export const mapToHtml = (rewards) => {
    const mappedRewards = rewards.map((reward, index) => {
        let logo;
        let name;

        switch (reward.profile?.giftType) {
            case 'cake':
                name = pluralize(reward.purchased_count, 'kake', 'kaker');
                logo = cake;
                break;
            case 'flower':
                name = pluralize(reward.purchased_count, 'blomst', 'blomster');
                logo = flower;
                break;
            case 'celebration':
                name = 'konfetti';
                logo = celebration;
                break;
            case 'card':
                name = 'kort';
                logo = card;
                break;
        }

        return (
            <div key={index} className={styles.gift}>
                <Icon fileUrl={logo} className={styles.logo} />
                <div className={styles.sold}>{reward.purchased_count}</div>
                <div className={styles.title}>{name}</div>
            </div>
        );
    });
    return mappedRewards;
};
